import React from "react";

const suraj_sonawane = () => {
  return (
    <div>
      <h1>Suraj Sonawane</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?
      </p>

      <p>
        1) Online Aptitude :- after online aptitude 25 students were selected
        <br />
        2) Technical Interview :- after the technical round 17 students for the
        next round.
        <br />
        3) Senior Managerial Round :- here all selected 17 students were
        interviewed
        <br />
        4) HR Interview :- after the hr 10 student were selected
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
      </p>

      <ol>
        <li>Aptitude Test </li>
        <li>Technical Interview :- 40min </li>
        <li>Senior Managerial Round </li>
        <li>HR Interview : 5-10 min </li>
      </ol>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
      </p>

      <p>This round consisted of four sections :</p>

      <p>
        1. <strong>English Proficiency</strong>
        <br />
        This section included questions on{" "}
        <strong>
          synonyms, antonyms, error detection, correct spellings, and
          fill-in-the-blanks
        </strong>{" "}
        to test verbal ability and grammar.
      </p>

      <p>
        2. <strong>Business-Related Aptitude</strong>
        <br />
        Candidates were asked to interpret{" "}
        <strong>graphs, pie charts, and histograms</strong> based on real-world
        business scenarios. This section assessed analytical and data
        interpretation skills.
      </p>

      <p>
        3. <strong>Coding Section</strong>
        <br />
        This section had <strong>two coding problems</strong> of{" "}
        <strong>easy to medium</strong> difficulty, focusing on{" "}
        <strong>problem-solving and algorithmic thinking</strong>.<br />
        Topics included concepts such as the{" "}
        <strong>two-pointer approach</strong> and <strong>binary search</strong>
        .
      </p>

      <p>
        4. <strong>Critical Thinking (Graph-Based Problem)</strong>
        <br />
        This section presented a{" "}
        <strong>challenging graph-related question</strong>, designed to test
        logical reasoning and algorithmic understanding.
        <br />
        In my case, the problem was based on <strong>Prim’s Algorithm</strong>,
        requiring the implementation of a <strong>minimum spanning tree</strong>{" "}
        solution.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
      </p>

      <p>
        After the aptitude round 25 students were selected for the next
        (interview) round.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
      </p>

      <p>
        After the shortlisting list was released on{" "}
        <strong>12th September</strong>, our interviews were scheduled for{" "}
        <strong>15th September</strong>, giving us around{" "}
        <strong>three days to prepare</strong>. During this period, I focused on
        strengthening the key areas mentioned in my resume, revising{" "}
        <strong>standard DSA problems</strong> from{" "}
        <strong>Striver’s DSA sheet</strong>, solving{" "}
        <strong>GFG puzzles</strong>, reviewing{" "}
        <strong>top DBMS interview questions</strong> from GeeksforGeeks,
        revising the <strong>fundamentals of full-stack development</strong>,
        and going through my <strong>projects in detail</strong> to ensure I
        could confidently explain their technical aspects and implementation.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
      </p>

      <p>
        There were three interview rounds – Technical, Technical + Managerial,
        and HR.
      </p>

      <ul>
        <li>
          <strong>Round 1: Technical Interview</strong>
          <br />
          In this round, the interviewer started with questions about my
          projects, asking me to explain my most fundamental project in detail.
          After that, they gave me two DSA problems - one of medium and one of
          medium-hard level, where the second problem was based on the first
          one. They also asked me a medium-level puzzle to test my logical
          thinking.
          <br />
          <em>
            (All shortlisted students were interviewed, and 17 students were
            selected for the next round.)
          </em>{" "}
        </li>
        <li>
          <strong>Round 2: Technical + Managerial Interview</strong>
          <br />
          This round again began with project-related questions, followed by a
          quick DSA question that I had to answer within 30 seconds - it was an
          easy-level problem testing my presence of mind. The interviewer also
          asked a few HR-type situational questions and one traditional puzzle
          to check my reasoning and communication.
          <br />
          <em>
            (All students from this round were interviewed, and the shortlisted
            ones were moved to the HR round.)
          </em>{" "}
        </li>
        <li>
          <strong>Round 3: HR Interview</strong>
          <br />
          This was focused on traditional HR questions - about strengths,
          weaknesses, teamwork, and future goals - to assess personality and
          cultural fit. (10 students )
        </li>
      </ul>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
      </p>

      <p>The interviewers mainly focused on:</p>

      <ul>
        <li>Data Structures and Algorithms (DSA) </li>
        <li>Puzzles and Logical Reasoning </li>
        <li>Project Explanation and Fundamentals </li>
        <li>Basic DBMS and Operating Systems concepts </li>
        <li>Behavioral and Situational Questions (in the HR round)</li>
      </ul>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
      </p>

      <ul>
        <li>
          <strong>DSA:</strong> I used <strong>Striver’s DSA Sheet</strong>,
          which is one of the best resources for structured and comprehensive
          DSA preparation, especially for placement-focused practice.{" "}
        </li>
        <li>
          <strong>Last-Minute Interview Preparation:</strong> For quick revision
          before interviews, I referred to <strong>GeeksforGeeks (GFG)</strong>{" "}
          - it’s great for brushing up on key concepts, common interview
          questions, and topic-wise summaries.{" "}
        </li>
      </ul>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
      </p>

      <p>
        · <strong>Practice DSA consistently:</strong> Regular practice is the
        key. Try to solve problems daily to strengthen your logic and
        problem-solving approach.
      </p>

      <p>
        · <strong>Start as early as possible:</strong> The earlier you begin,
        the more time you’ll have to understand concepts deeply and identify
        your weak areas -- this gives you a strong advantage later.
      </p>

      <p>
        · <strong>Work on projects in different domains:</strong> Building
        projects helps you apply your coding knowledge practically and makes
        your resume stronger.
      </p>

      <p>
        · <strong>Strengthen your computer science fundamentals:</strong> Be
        confident in core subjects like <strong>DBMS, OS, and OOPs</strong>, as
        they often come up in technical interviews alongside coding questions.{" "}
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?
      </p>

      <p>
        They asked{" "}
        <strong>plenty of questions related to my projects and resume</strong>,
        focusing on the technical aspects, implementation details, and my
        specific contributions. However,{" "}
        <strong>
          questions about extracurricular activities and clubs were very few
        </strong>
        , as the main emphasis was on my{" "}
        <strong>projects and technical skills</strong>.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?
      </p>

      <p>
        If you’re preparing for the same company, make sure you have a{" "}
        <strong>strong grasp of computer science fundamentals</strong> and{" "}
        <strong>DSA concepts</strong>, as the interviewers mainly focus on these
        areas. Practice solving <strong>DSA problems regularly</strong>, revise
        key topics like <strong>DBMS, OS, and OOPs</strong>, and be
        well-prepared to <strong>explain your projects in depth</strong>,
        including their technical implementation and your individual
        contribution.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
      </p>

      <p>
        Don’t waste the early years of your engineering journey - that time
        truly sets you apart from others. Start early with{" "}
        <strong>DSA practice</strong>, <strong>project building</strong>, and{" "}
        <strong>concept strengthening</strong>. The consistent efforts you put
        in from the beginning will give you a clear advantage during placements
        and internships.
      </p>

      <p>
        <strong>Contact Info</strong>{" "}
      </p>
      <p>
        <strong>Phone No :</strong> 9527385271
        <br />
        <strong>Email :</strong> <a href="mailto:sonawanesa23.comp@coeptech.ac.in">sonawanesa23.comp@coeptech.ac.in</a>
        <br />
        <strong>LinkedIn :</strong>{" "}
        <a href="https://www.linkedin.com/in/surajsonawane174/">
          Suraj Sonawane
        </a>
        <br />
      </p>
    </div>
  );
};

export default suraj_sonawane;
